export const Delete: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#D6453B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="m12.358 7.642-4.716 4.716M12.358 12.358 7.642 7.642M10 17.5A7.5 7.5 0 0 1 2.5 10 7.5 7.5 0 0 1 10 2.5a7.5 7.5 0 0 1 7.5 7.5 7.5 7.5 0 0 1-7.5 7.5"
    ></path>
  </svg>
);
